import {useContext, useEffect, useState} from "react";
import IGetApiKeysDTO from "../../../../models/DTO/IGetApiKeysDTO";
import IOnGetApiKeysDTO from "../../../../models/DTO/IOnGetApiKeysDTO";
import IOnProcessApiKeyDTO from "../../../../models/DTO/IOnProcessApiKeyDTO";
import IProcessApiKeyDTO from "../../../../models/DTO/IProcessApiKeyDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IApi_Key from "../../../../models/IApi_Key";
import INotification from "../../../../models/INotification";
import IOwTableCols from "../../../../models/IOwTableCols";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import OwButton from "../../../shared/OwButton/OwButton";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwTable from "../../../shared/OwTable/OwTable";
import { ApiKeySidebar } from "../ApiKeySidebar/ApiKeySidebar";
import "./ApiKey.scss";
import {ConfirmDeleteOverlayFn} from "../../../shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";
import {OwDeleteEditActions} from "../../../shared/OwDeleteEditActions/OwDeleteEditActions";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";
import {SocketContext} from "../../../../contexts/SocketContext";
import UiContext from "../../../../contexts/UiContext";
import IUiSocketSetup from "../../../../models/IUiSocketSetup";

type Props = {};

export const ApiKey = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const toggleApiSidebar = (apiKey?: IApi_Key) => {
        const sidebarComponent = (
            <ApiKeySidebar
                cancelFn={cancelSidebar}
                apiKey={apiKey}
            />
        );

        uiContext.setSidebarComponent(sidebarComponent);
        uiContext.toggleSidebar(true);
    };

    const actionsCol = (row: IApi_Key, index: number) => {
        return (
            <div>
                <OwDeleteEditActions isEditMode={false} onTrashClickFn={() => {
                    toggleConfirmDelete(row, index);
                }} onEditClickFn={() => {
                    toggleApiSidebar(row);
                }}/>
            </div>
        );
    };

    const getTableCols = (): IOwTableCols[] => {
        return [
            {
                title: "",
                valueProp: "",
                isActionsCol: true,
                renderFn: actionsCol,
                renderFnEmitsRow: true,
            },
            {
                title: "name",
                valueProp: "name",
            },
            {
                title: "key",
                valueProp: "api_key",
            },
        ]
    }

    const [apiKeys, setApiKeys] = useState<IApi_Key[]>([]);
    const [isActive, setIsActive] = useState(false);
    const [initialData, setInitialData] = useState(true);
    const [deleteRowElem, setDeleteRowElem] = useState<string | null>(null);
    const [tableCols, setTableCols] = useState(getTableCols());
    const [sourceRowElem, setSourceRowElem] = useState<IApi_Key | null>(null);

    const onGetApiKeys = (data: IOnGetApiKeysDTO) => {
        setApiKeys(data.apiKeys);
        setIsActive(false)
        setInitialData(false);
    };

    const sockets: IUiSocketSetup[] = [
        {endpoint: EndpointsEnum.SuppliersOnGetApiKeys, fn: onGetApiKeys}
    ];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        getApiKeys();

        return () => {
            for (const _socket of sockets) {
                socket.off(_socket.endpoint, _socket.fn);
            }
        }
    }, []);

    const toggleConfirmDelete = (row: IApi_Key, index: number) => {
        setDeleteRowElem(`row-api-${index}`)
        setSourceRowElem(row);
    };


    const getApiKeys = () => {
        const payload: IGetApiKeysDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
        };

        socket.emit(EndpointsEnum.SuppliersGetApiKeys, payload);

        setIsActive(true);
    };



    const cancelSidebar = () => {
        uiContext.setSidebarComponent(null);
        uiContext.toggleSidebar(false);
        getApiKeys();
    };

    const cancelDelete = () => {
        setDeleteRowElem(null);
        setSourceRowElem(null);
    };

    const commitDelete = () => {
        if (sourceRowElem) {
            const payload: IProcessApiKeyDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                deleteFlag: true,
                api_key: sourceRowElem.api_key,
            };

            socket.once(EndpointsEnum.SuppliersOnProcessApiKey, onProcessApiKey);

            socket.emit(EndpointsEnum.SuppliersProcessApiKey, payload);
        }
    };

    const onProcessApiKey = (data: IOnProcessApiKeyDTO) => {
        const notification: INotification = {
            message: "successfully_deleted_api_key",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        uiContext.notifyFn(null, notification);

        setSourceRowElem(null);
        setDeleteRowElem(null);

        getApiKeys();
    };

    return (
        <div className={"ApiKey position-relative"}>
            <div className={"row"}>
                <div className={"col-12 mb-2"}>
                    <a href={"https://docs.orderwerks.com/"} target={"_blank"} rel="noreferrer">
                        <OwLabel className={"pointer"} title={"view_api_docs"} leftIconClass={"fad fa-external-link-alt"} />
                    </a>
                </div>
            </div>

            <div className={"row"}>
                <div className={"col-12 mb-2"}>
                    <OwButton
                        title={"create"}
                        leftIconClass={"fas fa-plus"}
                        fn={() => {
                            toggleApiSidebar();
                        }}
                    />
                </div>
            </div>



            <div className="row position-relative">
                <div className="col-12 " >

                    <ConfirmDeleteOverlayFn
                        targetElem={deleteRowElem}
                        handleConfirm={commitDelete}
                        handleCancel={cancelDelete}
                        message={"confirm_delete"}
                        nestedParentElem={"api-key"}
                        skipMainView={true}
                        leftAdjustment={-12}
                    />

                    <OwTable
                        id={"api-key"}
                        tableRowClassName={'api-key-table-row'}
                        columns={tableCols}
                        dataSet={apiKeys}
                        userModel={userModel}
                        supplierModel={supplierModel}
                        dataFetch={isActive}
                        initialData={initialData}
                        rowIdName={"row-api"}
                    />
                </div>
            </div>
        </div>
    );
}
